import {
    MAIN_STYLE,
    MAIN_STYLE_GROUPS,
    PADDING_SIDES,
    SIGNED_PADDING_SIDES,
    LVGL_STYLE_INT_MIN,
    LVGL_STYLE_INT_MAX,
    TOGGLE_EVENTS,
} from '../shared.js'
export const switch_ = {

    displayName: 'Switch',

    // LVGL-style parts — label/exportSuffix/order are the source of truth for
    // the Property Editor and for legacy JSONL wire keys (see v2/shared.js
    // part metadata doc and v2/wireFormat.js toWireKey).
    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                ...MAIN_STYLE,
                // lv_switch.c:214-217 (and the ancestor lv_bar_design) read
                // pad_left/right/top/bottom on the BG part to inset the
                // indicator area — a real geometric effect, previously
                // unexposed here. 'main' is one of the 3 part names
                // ObjectExport.js's padding-expansion special-case handles
                // (see ObjectExport.js), so the exportSpecial shorthand is
                // safe and correct, mirroring knob's existing padding prop.
                padding:     { type: 'int', min: 0, exportSpecial: true },
                ...PADDING_SIDES,
                keep_circle: { type: 'bool', internal: true },
            },
        },
        indicator: {
            label: 'Indicator',
            exportSuffix: '10',
            order: 1,
            properties: {
                bg_color:     { type: 'color' },
                radius:       { type: 'int', min: 0, max: 999 },
                border_width: { type: 'int', min: 0 },
                border_color: { type: 'color' },
                keep_circle:  { type: 'bool', internal: true },
            },
        },
        knob: {
            label: 'Knob',
            exportSuffix: '20',
            order: 2,
            properties: {
                bg_color:     { type: 'color' },
                radius:       { type: 'int', min: 0, max: 999 },
                border_width: { type: 'int', min: 0 },
                border_color: { type: 'color' },
                // Legacy shorthand: total extra knob size, expanded as half
                // on each LVGL side. New edits use direct pad_* values.
                padding:      { type: 'int', min: LVGL_STYLE_INT_MIN, max: LVGL_STYLE_INT_MAX, exportSpecial: true },
                ...SIGNED_PADDING_SIDES,
                keep_circle:  { type: 'bool', internal: true },
            },
            paddingSidesAuthoritative: true,
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid:   { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled: { type: 'bool' }, hidden: { type: 'bool' },
        val:     { type: 'int' },
        groupid: { type: 'int', min: 0, max: 15, exportSpecial: true },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 80, height: 40, min_width: 40, min_height: 10,
            enabled: true, hidden: false,
            val: 0,
        },
        styles: {
            // border_width: 2 on all 3 parts matches firmware's BORDER_WIDTH
            // macro (lv_theme_hasp.c), applied to switch's bg/indicator/knob
            // via the shared 'pretty'/'pretty_color' theme styles.
            main:      { border_color: 'black', border_width: 2 },
            indicator: { border_width: 2, border_color: 'black' },
            knob:      { border_color: 'black', border_width: 2, padding: 2 },
        },
    },
    states: ['checked', 'pressed', 'pressedChecked', 'disabled', 'disabledChecked'],
    editorCapabilities:  ['can_transform', 'can_copy', 'has_objectmenu'],
    runtimeCapabilities: ['has_action', 'has_group'],

    events: TOGGLE_EVENTS,

    convertTo: ['btn', 'checkbox'],

    bindings: {
        properties: {
            val: {},
            bg_color: {},
            indicator: { bg_color: {} },
            knob: { bg_color: {} },
        },
        actions: { hass_services: ['', 'homeassistant', 'openhasp', 'automation', 'climate', 'light', 'switch', 'scene', 'esphome'] },
    },

    automation: {
        runtimeVariables: [
            { name: 'val', type: 'int', label: 'Switched On' },
        ],
        actionDomains: ['switch', 'light', 'homeassistant', 'openhasp', 'esphome'],
    },
}
